// Program-fit engine (spec §6.4). Deterministically compares what the developer
// program asks for against the rights envelope (from the rights engine) and the
// proposed-state matrix, splitting each line into נכנס / לא נכנס / דורש מסלול
// נוסף. The original request is preserved even when it doesn't fit.
import { computeRights, gatherInputs } from './rights-engine';
import { grandTotal } from '../state/matrix';

export function computeProgramFit(project, scenario) {
  const metrics = computeRights(gatherInputs(project));
  const allowedTotal = metrics.find((m) => m.key === 'allowedTotal');
  const allowedUnits = metrics.find((m) => m.key === 'allowedUnits');
  const proposedArea = grandTotal(scenario.matrix);
  const rows = [];

  // ---- total area: proposed matrix vs allowed ----
  if (allowedTotal.status === 'ok') {
    const requested = proposedArea;
    const allowed = allowedTotal.value;
    const over = Math.max(0, requested - allowed);
    rows.push({
      key: 'area',
      label: 'שטח כולל (מ"ר)',
      requested,
      fits: Math.min(requested, allowed),
      doesntFit: over,
      allowed,
      note: requested === 0 ? 'טרם מולאה מטריצת מצב מוצע'
        : over > 0 ? 'חורג מהזכויות — דורש מסלול תכנוני נוסף' : 'נכנס',
    });
  } else {
    rows.push({ key: 'area', label: 'שטח כולל (מ"ר)', requested: proposedArea, missing: true, note: 'חסר נתון זכויות (שטח מגרש / אחוזי בנייה)' });
  }

  // ---- units: program target vs allowed-by-density ----
  const targetUnits = scenario.program?.targetUnits;
  if (targetUnits != null && allowedUnits.status === 'ok') {
    const over = Math.max(0, targetUnits - allowedUnits.value);
    rows.push({
      key: 'units',
      label: 'יח"ד',
      requested: targetUnits,
      fits: Math.min(targetUnits, allowedUnits.value),
      doesntFit: over,
      allowed: allowedUnits.value,
      note: over > 0 ? 'דורש תוספת זכויות / מסלול נוסף' : 'נכנס',
    });
  } else if (targetUnits != null) {
    rows.push({ key: 'units', label: 'יח"ד', requested: targetUnits, missing: true, note: 'חסר נתון צפיפות לחישוב' });
  }

  return { rows, proposedArea };
}
